export const initialState = {
  leftDrawerOpened: true,
  openMenu: false,
  menuId: '',
  isOpen:[],
  borderRadius: 12
};
